<template>
  <div>
    <EndorsementList :subjectPermission="subjectPermission" />
  </div>
</template>
<script lang="ts">
import EndorsementCard from './components/EndorsementCard.vue';
import EndorsementList from './components/EndorsementList.vue';
export default {
  name: 'EndorsementAutomobile',
  components: { EndorsementCard, EndorsementList },
  props: ['subjectPermission'],
};
</script>
